module.exports = {
    showShareItems: false,
    /**
     * 主动调起“分享到朋友圈”分享内容接口
     * @method hysdk.shareTimeline
     * @category Fusion:Share
     * @description
     * 与 Hy 环境用法、参数格式相同
     */
    shareTimeline: {
        service: 'Share',
        action: 'callOneShare',
        tagname: 'call_one_share',
        optHandle: function optHandle(opt) {
            opt.shareType = 'WeixinCircle';
            opt.imageUrl = opt.imgUrl;
            opt.linkUrl = opt.link;
            opt.text = opt.desc;
            return opt;
        }
    },
    /**
     * 主动调起“分享给朋友”分享内容接口
     * @method hysdk.shareAppMessage
     * @category Fusion:Share
     * @description
     * 与 Hy 环境用法、参数格式相同
     */
    shareAppMessage: {
        service: 'Share',
        action: 'callOneShare',
        tagname: 'call_one_share',
        optHandle: function optHandle(opt) {
            opt.shareType = 'WeixinFriend';
            opt.imageUrl = opt.imgUrl;
            opt.linkUrl = opt.link;
            opt.text = opt.desc;
            return opt;
        }
    },
    /**
     * 主动调起“新浪微博”分享内容接口
     * @method hysdk.shareWeiboApp
     * @category Fusion:Share
     * @description
     * 与 Hy 环境用法、参数格式相同
     */
    shareWeiboApp: {
        service: 'Share',
        action: 'callOneShare',
        tagname: 'call_one_share',
        optHandle: function optHandle(opt) {
            opt.shareType = 'SinaWeibo';
            opt.imageUrl = opt.imgUrl;
            opt.linkUrl = opt.link;
            opt.text = opt.desc;
            return opt;
        }
    },
    /**
     * 主动调起“短信”分享内容接口
     * @method hysdk.shareSMS
     * @category Fusion:Share
     * @description
     * 与 Hy 环境用法、参数格式相同
     */
    shareSMS: {
        service: 'Share',
        action: 'callOneShare',
        tagname: 'call_one_share',
        optHandle: function optHandle(opt) {
            opt.shareType = 'SMS';
            opt.imageUrl = opt.imgUrl;
            opt.linkUrl = opt.link;
            opt.text = opt.desc;
            return opt;
        }
    },
    /**
     * 主动调起“邮件”分享内容接口
     * @method hysdk.shareEmail
     * @category Fusion:Share
     * @description
     * 与 Hy 环境用法、参数格式相同
     */
    shareEmail: {
        service: 'Share',
        action: 'callOneShare',
        tagname: 'call_one_share',
        optHandle: function optHandle(opt) {
            opt.shareType = 'Email';
            opt.imageUrl = opt.imgUrl;
            opt.linkUrl = opt.link;
            opt.text = opt.desc;
            return opt;
        }
    },
    shareQunarIM: false,
    registerScreenshotShare: false,
    unregisterScreenshotShare: false,
    screenshotAndShare: false
};


//////////////////
// WEBPACK FOOTER
// ../plugins/ctrip/apis/share.js
// module id = 42
// module chunks = 1 4